const {
  FLITCH_INVENTORY_FAILED,
  FLITCH_INVENTORY_REQUEST,
  FLITCH_INVENTORY_SUCCESS,
  FLITCH_HISTORY_INVENTORY_REQUEST,
  FLITCH_HISTORY_INVENTORY_SUCCESS,
  FLITCH_HISTORY_INVENTORY_FAILED,
} = require("app/redux/actions/Inventory/flitch/constants");

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const flitchInventoryReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case FLITCH_INVENTORY_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case FLITCH_INVENTORY_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case FLITCH_INVENTORY_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};

const FLITCH_HISTORY_INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
      isError: false,
      message: null
  }
};

export const flitchHistoryInventoryReducer = function (state = FLITCH_HISTORY_INIT_STATE, action) {
    switch (action?.type) {
        case FLITCH_HISTORY_INVENTORY_REQUEST:
            return {
                loading: true,
                totalPage: 0,
                data: [],
                error: {
                    isError: false,
                    message: null
                }
            }
        case FLITCH_HISTORY_INVENTORY_SUCCESS:
            return {
                loading: false,
                data: action?.payload?.data,
                totalPage: action?.payload?.totalPage,
                error: {
                    isError: false,
                    message: null
                }
            }
        case FLITCH_HISTORY_INVENTORY_FAILED:
            const { isError = true, message = "Something Went Wrong" } = action?.payload?.error || {}
            return {
                loading: false,
                totalPage: 0,
                data: [],
                error: {
                    isError: isError,
                    message: message
                }
            }
        default:
            return state;
    }
};